import React, {useEffect, useState} from 'react'
// Styles
import formStyles from './forms.module.scss'

interface InputTextfieldProps {
  id: string
  label: string
  instructions?: React.ReactNode | null
  placeholder?: string
  initialValue?: string
  errorMessage?: string | null
  isDisabled?: boolean
  isSmall?: boolean
  isWhite?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement> | { target: { value: string } }) => void
  characterLimit?: number | null
}

const InputTextfield = ({
  id,
  label,
  instructions = null,
  placeholder,
  initialValue = '',
  errorMessage = null,
  isDisabled = false,
  isSmall = false,
  isWhite = false,
  onChange,
  characterLimit = null,
}: InputTextfieldProps) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleChange = (syntheticEvent: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = syntheticEvent.target.value

    if (characterLimit && newValue.length > characterLimit) {
      setValue(newValue.slice(0, characterLimit))

      const modifiedEvent = {
        ...syntheticEvent,
        target: {
          ...syntheticEvent.target,
          value: newValue.slice(0, characterLimit),
        },
      }

      if (onChange) onChange(modifiedEvent)
    } else {
      setValue(newValue)
      if (onChange) onChange(syntheticEvent)
    }
  }

  return (
    <div
      key={`field-${id}`}
      className={formStyles['__textfield-wrapper']}
    >
      <label className={formStyles['__label']}>{label}</label>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`${formStyles['__field']} ${isSmall && formStyles['--is-small']} ${isWhite && formStyles['--is-white']} ${isDisabled && formStyles['--is-disabled']}`}
        disabled={isDisabled}
      />
      {errorMessage && (
        <span className={formStyles['__error-message']}>
          {errorMessage}
        </span>
      )}
      <div className={formStyles['__instructions']}>
        {instructions}
        {characterLimit && (
          <span className={formStyles['__character-limit']}>
            &nbsp;Character Limit: {value.length}/{characterLimit}
          </span>
        )}
      </div>
    </div>
  )
}

export default InputTextfield
